import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDatepicker, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AppsSharedModule, BaseAssignmentsModule, BaseInquiryModule, BaseOffersModule, BaseSharedModule } from 'base';
import { BaseCustomerInquiryUnlimitedOffersComponent } from './_components/inquiry-unlimited-offers/base-customer-inquiry-unlimited-offers.component';
import { BaseCustomerInquiryService } from './inquiry.service';
import { BaseCustomerOfferInfoModalComponent } from './_components/offer-info-modal/base-customer-offer-info-modal.component';
import { BaseCustomerOfferInformationTabComponent } from './_components/offer-info-modal/offer-information-tab/base-customer-offer-information-tab.component';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerInquiryListComponent } from './_components/inquiry-list/base-customer-inquiry-list.component';
import { BaseCustomerInquiryListFiltersComponent } from './_components/inquiry-list/inquiry-list-filters/base-customer-inquiry-list-filters.component';
import { BaseCustomerShiftPlanComponent } from './_components/shift-plan/base-customer-shift-plan.component';
import { BaseCustomerShiftDetailsModalComponent } from './_components/shift-plan/details-modal/base-customer-shift-details-modal.component';
import { BaseCustomerShiftPlanSidebarComponent } from './_components/shift-plan/sidebar/base-customer-shift-plan-sidebar.component';
import { BaseCustomerSortFilterDropdownComponent } from './_components/sort-filter-dropdown/base-customer-sort-filter-dropdown.component';
import { InquiryOffersListFiltersComponent } from './_components/inquiry-offers-list-filters/inquiry-offers-list-filters.component';
import { BaseCustomerInquiryOffersComponent } from './_components/inquiry-offers/base-customer-inquiry-offers.component';
import { BaseCustomerInquiryOffersListComponent } from './_components/inquiry-offers/inquiry-offers-list/base-customer-inquiry-offers-list.component';
import { BaseCustomerOfferInfoMasterDataTabComponent } from './_components/offer-info-modal/offer-master-data-tab/base-customer-offer-master-data-tab.component';
import { BaseCustomerOfferDocumentsTabComponent } from './_components/offer-info-modal/offer-documents-tab/base-customer-offer-documents-tab.component';
import { BaseCustomerOfferDocumentComponent } from './_components/offer-info-modal/offer-master-data-tab/_components/base-customer-offer-document/base-customer-offer-document.component';
import { BaseCustomerOffersSearchAndLegendComponent } from './_components/offers-search-and-legend/base-customer-offers-search-and-legend.component';
import { BaseCustomerOfferBubbleListComponent } from './_components/offer-bubble-list/base-customer-offer-bubble-list.component';
import { BaseCustomerOfferBubbleComponent } from './_components/offer-bubble/base-customer-offer-bubble.component';
import { BaseCustomerOfferAvailableShiftTypeExistsPipe } from './_pipes/base-customer-offer-available-shift-type-exists.pipe';
import { BaseCustomerOfferActionsComponent } from './_components/offer-actions/base-customer-offer-actions.component';
import { BaseCustomerShiftPlanCalendarComponent } from './_components/shift-plan/calendar/base-customer-shift-plan-calendar.component';
import { BaseCustomerShiftPlanCalendarDatesComponent } from './_components/shift-plan/calendar/dates/base-customer-shift-plan-calendar-dates.component';
import { BaseCustomerShiftPlanBubbleComponent } from './_components/shift-plan/bubble/base-customer-shift-plan-bubble.component';
import { BaseCustomerShiftPlanSimilarInquiriesComponent } from './_components/shift-plan/similar-inquiries/base-customer-shift-plan-similar-inquiries.component';
import { BaseSimilarInquiriesDatesListComponent } from './_components/shift-plan/similar-inquiries/dates/base-similar-inquiries-dates-list.component';
import { CloseInquiryFormComponent } from './_components/close-inquiry-form/close-inquiry-form.component';
import { BaseCustomerUnlimitedOfferActionsComponent } from './_components/unlimited-offer-actions/base-customer-unlimited-offer-actions.component';
import { BaseCustomerInquiryOfferComponent } from './_components/inquiry-offers/inquiry-offer/base-customer-inquiry-offer.component';
import { BaseCustomerInquiryListItemComponent } from './_components/inquiry-list/inquiry-list-item/base-customer-inquiry-list-item.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    BaseSharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    AppsSharedModule,
    BaseInquiryModule,
    BaseAssignmentsModule,
    BaseOffersModule,
    BaseCustomerSharedModule,
    NgbDatepicker,
  ],
  declarations: [
    BaseCustomerOfferBubbleComponent,
    BaseCustomerOfferInfoModalComponent,
    BaseCustomerOfferInfoMasterDataTabComponent,
    BaseCustomerOfferDocumentsTabComponent,
    BaseCustomerOfferInformationTabComponent,
    BaseCustomerOffersSearchAndLegendComponent,
    BaseCustomerInquiryListComponent,
    BaseCustomerInquiryListFiltersComponent,
    BaseCustomerInquiryUnlimitedOffersComponent,
    BaseCustomerShiftPlanComponent,
    BaseCustomerShiftDetailsModalComponent,
    BaseCustomerShiftPlanSidebarComponent,
    BaseCustomerSortFilterDropdownComponent,
    InquiryOffersListFiltersComponent,
    BaseCustomerOfferDocumentComponent,
    BaseCustomerInquiryOffersComponent,
    BaseCustomerInquiryOffersListComponent,
    BaseCustomerOfferBubbleListComponent,
    BaseCustomerShiftPlanCalendarComponent,
    BaseCustomerShiftPlanCalendarDatesComponent,
    BaseCustomerShiftPlanBubbleComponent,
    BaseCustomerOfferAvailableShiftTypeExistsPipe,
    BaseCustomerOfferActionsComponent,
    BaseCustomerShiftPlanSimilarInquiriesComponent,
    BaseSimilarInquiriesDatesListComponent,
    CloseInquiryFormComponent,
    BaseCustomerUnlimitedOfferActionsComponent,
    BaseCustomerInquiryOfferComponent,
    BaseCustomerInquiryListItemComponent,
  ],
  exports: [
    BaseCustomerOfferBubbleComponent,
    BaseCustomerOfferInfoModalComponent,
    BaseCustomerOfferInfoMasterDataTabComponent,
    BaseCustomerOfferDocumentsTabComponent,
    BaseCustomerOfferInformationTabComponent,
    BaseCustomerOffersSearchAndLegendComponent,
    BaseCustomerInquiryListComponent,
    BaseCustomerInquiryListFiltersComponent,
    BaseCustomerInquiryUnlimitedOffersComponent,
    BaseCustomerShiftPlanComponent,
    BaseCustomerShiftDetailsModalComponent,
    BaseCustomerShiftPlanSidebarComponent,
    BaseCustomerSortFilterDropdownComponent,
    InquiryOffersListFiltersComponent,
    BaseCustomerOfferDocumentComponent,
    BaseCustomerInquiryOffersComponent,
    BaseCustomerInquiryOffersListComponent,
    BaseCustomerOfferBubbleListComponent,
    BaseCustomerShiftPlanBubbleComponent,
    BaseCustomerShiftPlanSimilarInquiriesComponent,
    BaseSimilarInquiriesDatesListComponent,
    CloseInquiryFormComponent,
    BaseCustomerUnlimitedOfferActionsComponent,
    BaseCustomerInquiryOfferComponent,
    BaseCustomerInquiryListItemComponent,
  ],
  providers: [BaseCustomerInquiryService, BaseCustomerOfferAvailableShiftTypeExistsPipe],
})
export class BaseCustomerInquiryModule {}
